import React from 'react'
import { Switch } from '../../../components'
import { getFormattedLabel } from '../../../utils/helpers'
import { useTheme } from '../../../index'
import { useNotificationsHomeContext } from '../../context'

export const GlobalPreference = ({ channels }) => {
  const theme = useTheme()
  const {
    data: { globalChannelPreference },
    handlers: {
      setGlobalChannelPreference,
      setUserPreference,
      setUpdatedPreference
    }
  } = useNotificationsHomeContext()

  const setGlobalPreference = (channel, value) => {
    if (value === 'on') {
      setUserPreference((prev) => {
        let temp = { ...prev }
        Object.keys(prev.result).forEach((preference) => {
          prev.result[preference].forEach((section) => {
            let optedState =
              section.channel_config[channel] === 'on' ? 'opted-in' : 'required'

            if (section.channel_config[channel] === 'required') {
              return
            }

            if (section.preference[channel]) {
              section.preference[channel] =
                section.channel_config[channel] === 'off'
                  ? 'opted-out'
                  : optedState
            }

            setUpdatedPreference((prev) => {
              let temp = { ...prev }

              if (!temp[section.subscription_id]) {
                temp[section.subscription_id] = {}
              }

              temp[section.subscription_id][channel] =
                section.channel_config[channel] === 'off'
                  ? 'opted-out'
                  : optedState
              return temp
            })
          })
        })

        return temp
      })
    } else {
      setUserPreference((prev) => {
        let temp = { ...prev }

        return temp
      })
    }
    setUpdatedPreference((prev) => {
      let temp = { ...prev }
      if (!temp['all']) temp['all'] = {}
      temp['all'][channel] = value === 'on' ? 'opted-in' : 'opted-out'
      return temp
    })
    setGlobalChannelPreference((prev) => {
      const temp = { ...prev }
      temp[channel] = !temp[channel]
      return temp
    })
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        paddingTop: '1.25rem',
        gap: '1.25rem'
      }}
    >
      {channels.map((channel) => (
        <div
          key={channel}
          style={{
            display: 'flex',
            gap: '2rem',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
            <p
              style={{
                fontSize: '14px',
                fontWeight: 600,
                color: theme.palette.text.primary,
                margin: 0
              }}
            >
              Notify me on {getFormattedLabel(channel)}
            </p>
            {globalChannelPreference[channel] ? (
              <p
                style={{
                  fontSize: '12px',
                  fontWeight: 300,
                  color: theme.palette.text.primary,
                  margin: '2px 0 0 0'
                }}
              >
                By enabling this, you will receive communications as per your
                preference.
              </p>
            ) : (
              <p
                style={{
                  fontSize: '12px',
                  fontWeight: 300,
                  color: theme.palette.text.primary,
                  margin: '2px 0 0 0'
                }}
              >
                By opting out, you won't receive any communications on this
                channel.
              </p>
            )}
          </div>
          <Switch
            checked={!globalChannelPreference[channel]}
            onChange={() =>
              setGlobalPreference(
                channel,
                globalChannelPreference[channel] ? 'on' : 'off'
              )
            }
            size='small'
          />
        </div>
      ))}
    </div>
  )
}

export default GlobalPreference
